<div class="flex items-center justify-between">
  <div class="flex-1">
    @if (selectedProviders().length === 0 && selectedDocumentTypes().length === 0) {
      <span>{{ 'chatMessages.filter.subline' | transloco }}</span>
    }

    @if (selectedProviders().length > 0 || selectedDocumentTypes().length > 0) {
      <div class="flex flex-wrap items-center gap-2">
        @for (docType of selectedDocumentTypes(); track docType) {
          <p-button
            variant="text"
            severity="contrast"
            (click)="removeFilterValue(docType, 'documentType')"
            class="group [&_.p-button]:h-8 [&_.p-button]:!border [&_.p-button]:!border-zinc-200 [&_.p-button]:py-0">
            <span>{{ 'source.category.' + docType | transloco }}</span>
            <i class="pi pi-times-circle text-zinc-400 group-hover:text-zinc-600"></i>
          </p-button>
        }

        @for (provider of selectedProviders(); track provider) {
          <p-button
            variant="text"
            severity="contrast"
            (click)="removeFilterValue(provider, 'provider')"
            class="group [&_.p-button]:h-8 [&_.p-button]:!border [&_.p-button]:!border-zinc-200 [&_.p-button]:py-0">
            <app-source-link-logo [provider]="provider" class="shrink-0 [&_p-tag]:bg-transparent" />
            <i class="pi pi-times-circle text-zinc-400 group-hover:text-zinc-600"></i>
          </p-button>
        }

        <!-- Clear filter button -->
        <p-button
          icon="pi pi-times"
          [label]="'chatMessages.filter.resetFilters' | transloco"
          variant="text"
          severity="contrast"
          iconPos="left"
          (click)="clearAllFilters()"
          class="[&_.p-button-icon]:pt-[2px] [&_.p-button-icon]:text-xs [&_.p-button]:h-8 [&_.p-button]:!px-2 [&_.p-button]:!py-0" />
      </div>
    }
  </div>

  <!-- Add filter button -->
  <p-button
    icon="pi pi-sliders-h"
    [label]="'Filter'"
    variant="text"
    severity="contrast"
    iconPos="left"
    (click)="toggle($event)"
    class="[&_.p-button-icon]:pt-[2px] [&_.p-button-icon]:text-xs [&_.p-button]:h-8 [&_.p-button]:!px-2 [&_.p-button]:!py-0" />

  <p-popover #filterPopover [dismissable]="true" class="pos-bottom-right">
    <p-listbox
      [(ngModel)]="_filterValues"
      [group]="true"
      [showToggleAll]="false"
      [options]="(allFilterOptions() | async) ?? []"
      [multiple]="true"
      [checkbox]="true"
      optionLabel="name"
      scrollHeight="30rem"
      (onChange)="onFilterChange()"
      class="!border-0 [&_.p-listbox-option-group]:mt-4 [&_.p-listbox-option-group]:px-1" />
  </p-popover>
</div>
